export default __webpack_public_path__ + "assets/dbd7019607e87550b41a05ddcd5c060c.png";